import React from "react";
import {PageHero} from "../common/PageHero";

const teams = [
    {name: 'Ploeg A', division: 'Afdeling 3', players: 'Vincent Bart Noah Arno'},
    {name: 'Ploeg B', division: 'Afdeling 5A', players: 'Jöel Levi Jos Gert'},
    {name: 'Ploeg C', division: 'Afdeling 5B', players: 'Thomas Lode Eduardo Filip'},
    {name: 'Ploeg D', division: 'Afdeling 7A', players: 'Guido Lawrens Johan Koen Wouter'},
    {name: 'Ploeg E', division: 'Afdeling 7B', players: 'Glenn Emmanuel Jonas Niels'},
    {name: 'Ploeg F', division: 'Afdeling 9A', players: 'Lieve Rudy Jean Nathalie'},
    {name: 'Ploeg G', division: 'Afdeling 9B', players: 'Luc Guy Els'},
    {name: 'Jeugd A', division: 'Afdeling 5', players: 'Rinus Trever Levin Tristan Xander'}
];

export const Teams = () => {
    return (
        <>
            <PageHero title={'Ploegen'}
                      badge={'Competitie'}
                      lead={'Onze ploegen en hun samenstelling voor dit seizoen.'}/>
            <div className={'ttc-section'}>
                <div className={'ttc-card-grid'}>
                    {teams.map((team) => (
                        <div className={'ttc-card'} key={team.name}>
                            <div className={'ttc-card-head'}>
                                <h3 className={'ttc-card-title'}>{team.name}</h3>
                                <span className={'ttc-tag'}>{team.division}</span>
                            </div>
                            <p className={'ttc-card-body'}>{team.players}</p>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
}
